module.exports = __webpack_public_path__ + "media/images/players/PIETERS_THOMAS-5688f03bd140f05742fce1a65d1510ca.png";